import React from "react";

import { Typography } from "clearsense-ui/components";
import { DataFlow } from "images/LandingPage";

import { FEATURES } from "./constants";

const Features = () => (
  <>
    <div className="feature-wrapper">
      <div className="mx-10 w-full overflow-hidden flex justify-center">
        <img src={DataFlow} alt="" className="w-full object-cover" />
      </div>
    </div>
    <div className="mx-40 mt-10 flex justify-center w-full">
      <div className="grid grid-cols-3 gap-x-6 gap-y-8 w-full">
        {FEATURES.general.map(feature => (
          <div
            className="flex items-center h-20 gap-6 w-80 justify-items-start"
            key={feature.title}
          >
            <div className="flex items-center justify-center bg-white rounded-full shadow-lg h-14 w-14">
              <img src={feature.icon} />
            </div>
            <Typography type="semibold" style="h5" className="w-60">
              {feature.title}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  </>
);

export default Features;
